export const copyObject = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}